import { MissionOption } from "@/modules/employees/models/Mission";

const MISSIONS_OPTIONS: MissionOption[] = [
  { label: "Giao hàng", code: "GIAO_HANG" },
  { label: "Khảo sát", code: "KHAO_SAT" },
  { label: "CNC", code: "CNC" },
  { label: "Bán hàng", code: "BAN_HANG" },
  { label: "Nhập kho", code: "NHAP_KHO" },
  { label: "Xuất kho", code: "XUAT_KHO" },
];

export { MISSIONS_OPTIONS };